export const routes = {
    parkSafePledge: "/park-safe/pledge",
    parkSafeFAQ: "/park-safe/faq",
    homePage: "/"
};
